import React from 'react';
import './services.scss';
import Breadcrumb from '../../shared/breadcrumb/breadcrumb';
import Slider from './slider/slider';
import MedicalServices from './medical-services/medical-services';
import Prices from './prices/prices';
import Guide from './guide/guide';
import PaymentMethods from './payment-methods/payment-methods';
import { useStore } from 'hooks/useStore';

export function Services() {
  const {
    state: {
      services: {
        ads,
        medicalServices,
        filesWithPrices,
        filesWithServiceDescription
      }
    }
  } = useStore();

  return (
    <main>
      <Breadcrumb
        links={[
          { to: '/', text: 'Главная' },
          { to: '/services', text: 'Платные услуги' }
        ]}
      />
      {/* /breadcrumb */}

      <div className="container margin_60">
        <div className="main_title">
          <a id="anchorMedicalServices" />
          <h1>Платные услуги</h1>
          <p>Мы предоставляем широкий диапазон услуг.</p>
        </div>
        <div className="add_bottom_45">
          <Slider ads={ads} />
        </div>
        <div className="add_bottom_45">
          <MedicalServices items={medicalServices} />
        </div>
        <div className="add_bottom_45">
          <a id="anchorPrices" />
          <Prices files={filesWithPrices} />
        </div>
        <div className="add_bottom_45">
          <a id="anchorDescription" />
          <Guide files={filesWithServiceDescription} />
        </div>
        <div>
          <PaymentMethods />
        </div>
      </div>
    </main>
  );
}

export default Services;
